module.exports = __webpack_public_path__ + "media/application/images/icons/topics-climate-change-pebble-dark-green-rgb-3bb3eb293c6614e85ec0a795ed27a88f.svg";